var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"changjing-column"},[_c('el-page-header',{attrs:{"content":"栏目列表"},on:{"back":function($event){return _vm.$router.push('/changjing')}}}),_c('c-tag-level',{attrs:{"type":"changjing"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }